import { v4 as uuidv4 } from "uuid";
import { SHA256 } from "crypto-js";
import store from "store";

export function getOrCreateDeviceToken() {
  const key = "device_token";
  let token = store.get(key);

  if (!token) {
    const raw = `${uuidv4()}${Date.now()}`;
    const hash = SHA256(raw).toString(); // full SHA256
    token = hash.substring(0, 32); // boleh dipotong, misal 32 karakter
    store.set(key, token);
  }

  return token;
}
